jQuery(document).ready(function(){
    initBrowserCheck();
    mobilenav();
    initAccordion();
    initModal();
});

// Init BrowserCheck
function initBrowserCheck() {
    function isIE() {
        ua = navigator.userAgent;
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

        return is_ie;
    }

    /* Create an alert to show if the browser is IE or not */
    if ( isIE() ) {
        jQuery('.notice-browser').show();
    }
}

function mobilenav() {
    jQuery('.nav-toggle').on('click', function() {
        jQuery('#nav-icon').toggleClass('open');
        jQuery('body').toggleClass('body_modal');
        jQuery('.mobile-navigation').toggleClass('show_nav');
    });
}

function initAccordion() {
    jQuery('.step__title').on('click', function(){
        var thisOne = jQuery(this),
            thisStep = thisOne.closest('.step')

        setTimeout( function() {
            jQuery('.step').not(thisStep).removeClass('active')
            thisStep.toggleClass('active')
        }, 500);
    })
}

function initModal() {
    jQuery('.modalOpen').on('click', function() {
        jQuery('.modal').toggleClass('show_modal');
        jQuery('body').toggleClass('body_modal');
    });
    jQuery('.modal_close').on('click', function() {
        jQuery('.modal').toggleClass('show_modal');
        jQuery('body').toggleClass('body_modal');
    });
}
